import { ref } from 'vue';
import type { Ref } from 'vue';

import type { MODAL } from '@/utils/useModal/types';
import { COMPLEX_SELECT } from '@/components/form-elements/ComplexSelect/types';
import {
  ModalCloseEvent,
  ModalOpenEvent,
} from '@/utils/useModal/trackingEvents';
import { useTagManager } from '@demv_systems/feu-tag-manager';

export interface UseModal {
  showModal: Ref<boolean>;
  open: () => void;
  close: () => void;
}

export interface ModalExposedFunctions {
  open: () => void;
  close: () => void;
}

export const useModal = (modal: MODAL | COMPLEX_SELECT): UseModal => {
  const showModal = ref(false);

  const open = (): void => {
    showModal.value = true;

    const openEvent: ModalOpenEvent = {
      event: 'modalOpen',
      name: modal,
    };
    useTagManager().push(openEvent);
  };
  const close = (): void => {
    showModal.value = false;

    const closeEvent: ModalCloseEvent = {
      event: 'modalClose',
      name: modal,
    };
    useTagManager().push(closeEvent);
  };

  return {
    showModal,
    open,
    close,
  };
};
